module.exports = __webpack_public_path__ + "static/media/mmExt1.9a32f8ac.jpg";